import React from 'react';
import TableGraph from './TableGraph';
import Pagination from './Pagination';
import { Chart, GoogleChartWrapperChartType, GoogleDataTableColumn, GoogleDataTableRow } from 'react-google-charts';

interface ChartRendererProps {
  data?: any[];
  title: string;
  chartId: string;
  isTable: boolean;
  options?: object;
  className?: string;
  hasValidData: boolean;
  rows?: GoogleDataTableRow[];
  ragColoringColumns?: number[];
  hideColumnsByIndex?: string[];
  hideSortingOnColumns?: string[];
  columns?: GoogleDataTableColumn[];
  styleChart?: React.CSSProperties;
  chartType: GoogleChartWrapperChartType | string;
  onRowSelect?: (props: any) => void;
  onSortChange?: (chartId: string, columnId: string, desc: boolean) => void;
  onPaginationChange?: (action: 'next' | 'previous' | 'page', pageNumber?: number) => void;
  onScroll?: (chartId: any, event: React.WheelEvent<HTMLDivElement>, scrollDirectionZ?: "up" | "down", chartType?: string) => void;
  paginationInfo?: {
    currentPage: number;
    totalPages: number;
    totalRecords: number;
    limit: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startRecord: number;
    endRecord: number;
  } | null;
}

const ChartRenderer: React.FC<ChartRendererProps> = ({
  title,
  data,
  rows,
  isTable,
  columns,
  options,
  chartId,
  onScroll,
  className,
  chartType,
  styleChart,
  onRowSelect,
  hasValidData,
  onSortChange,
  paginationInfo,
  ragColoringColumns,
  hideColumnsByIndex,
  onPaginationChange,
  hideSortingOnColumns,
}) => {
  if (!hasValidData) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
        <h3>{title}</h3>
        <p>No data available to display the chart.</p>
      </div>
    );
  }

  if (isTable) {
    return (
      <TableGraph
        data={data || []}
        ragColoringColumns={ragColoringColumns}
        hideColumnsByIndex={hideColumnsByIndex}
        hideSortingOnColumns={hideSortingOnColumns}
        onScrollEnd={() => {
          // Call onScroll handler when reaching bottom
          onScroll?.(chartId || '', {} as any, 'down', chartType);
        }}
        onSortChange={(columnId, desc) => {
          // Trigger data refetch with new sort parameters
          if (onSortChange && chartId) {
            onSortChange(chartId, columnId, desc);
          }
        }}
        onRowSelect={onRowSelect}
      />
    );
  }

  return (
    <div style={{ position: 'relative', height: '90%' }}>
      <Chart
        rows={rows}
        data={data}
        height="90%"
        columns={columns}
        options={options}
        style={styleChart}
        className={className}
        chartType={chartType as GoogleChartWrapperChartType}
        chartEvents={[{ eventName: 'select', callback: onRowSelect || (() => {}) }]}
      />
      {paginationInfo && onPaginationChange && (
        <Pagination
          paginationInfo={paginationInfo}
          chartId={chartId}
          onPaginationChange={onPaginationChange}
        />
      )}
    </div>
  );
};

export default ChartRenderer;
